import { useContext } from "react";
import CheckoutContext from "../../checkout-context";

export function MultiStepHeader() {
  const {
    textsMapping,
    isModuleStepActive,
    isPersonalStepActive,
    isSummaryStepActive,
    goToStep,
    hasModuleScheduler,
  } = useContext(CheckoutContext);

  const personalStepIsFinished = !isModuleStepActive && !isPersonalStepActive;
  const summaryStepIsFinished = personalStepIsFinished && !isSummaryStepActive;

  return (
    <div className="checkout__header">
      <section className="multi-step__header">
        <ul>
          {hasModuleScheduler && (
            <li className={`${isModuleStepActive ? "active" : "finished"}`}>
              <button type="button" onClick={() => goToStep("jump", 0)}>
                <span className="multi-step__header-label">1</span>
                <span className="multi-step__header-title">
                  {textsMapping.stepTwoTitle}
                </span>
              </button>
            </li>
          )}
          <li
            className={`${isPersonalStepActive ? "active" : ""} ${
              personalStepIsFinished ? "finished" : ""
            }`}
          >
            <button
              type="button"
              onClick={() =>
                personalStepIsFinished &&
                goToStep("jump", hasModuleScheduler ? 1 : 0)
              }
            >
              <span className="multi-step__header-label">
                {hasModuleScheduler ? 2 : 1}
              </span>
              <span className="multi-step__header-title">
                {textsMapping.stepThreeTitle}
              </span>
            </button>
          </li>
          <li
            className={`${isSummaryStepActive ? "active" : ""} ${
              summaryStepIsFinished ? "finished" : ""
            }`}
          >
            <button type="button">
              <span className="multi-step__header-label">
                {hasModuleScheduler ? 3 : 2}
              </span>
              <span className="multi-step__header-title">
                {textsMapping.stepFourTitle}
              </span>
            </button>
          </li>
        </ul>
      </section>
    </div>
  );
}
